import React, { useState, useEffect } from "react";
import { Box, DialogActions, DialogContent } from "@mui/material";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import DropDownComponent from "../../../atom/Inputs/DropDown";
import { DatePickerComponent, TimePickerComponent } from "../../../atom";
import { useDispatch } from 'react-redux';
import { Actions } from "../../../../core/modules/Actions";
import { connect } from 'react-redux';
import { convertStringDate, convertStringTime } from "../../../../core/Constant";
import dayjs from 'dayjs';

const AdminWebinarUpdateForm = ({ onClose, courseList, getCourseList, webinarDetails, webinarById, getWebinarById, }) => {
    const dispatch = useDispatch();
    const [newWebinar, setNewWebinar] = useState({
        name: '',
        date: '',
        time: '',
        time_ext: 'AM',
        duration: '',
        is_recurring: false,
        recurrence_type: 2,
        repeat_interval: 1,
        weekly_days: '',
        monthly_day: '',
        end_times: '',
        end_date_time: '',
        course: ''
    });

    const [errors, setErrors] = useState({
        name: '',
    date: "",
    time: "",
    duration: "",
    is_recurring: false,
    recurrence_type: "",
    repeat_interval: "",
    weekly_days: "",
    monthly_day: "",
    end_times: "",
    end_date_time: "",
    course: "",
    });

    useEffect(() => {
        setNewWebinar(prev => ({
            ...prev,
            name: webinarDetails?.name || '',
            date: webinarDetails?.date ? new Date(webinarDetails?.date) : '',
            time: webinarDetails?.time ? dayjs(webinarDetails?.time, "HH:mm:ss") : '',
            duration: webinarDetails?.duration || '',
            course: webinarDetails?.course_id || '',
            is_recurring: Boolean(webinarDetails.is_recurring),
            recurrence_type: Number(webinarDetails.recurrence_type ?? 2),
            repeat_interval: webinarDetails.repeat_interval ?? 1,
            weekly_days: webinarDetails.weekly_days || "",
            monthly_day: webinarDetails.monthly_day || "",
            end_times: webinarDetails?.end_times || '',
            end_date_time: webinarDetails.end_date_time
            ? new Date(webinarDetails?.end_date_time)
            : '',
        }));
       }, [webinarDetails]);

    useEffect(() => {
        getCourseList();
        // getWebinarById(webinarId);
    }, []);

    const emptyFormfields = () => {
        setNewWebinar({
            name: '',
            date: "",
      time: "",
      time_ext: "AM",
      duration: "",
      is_recurring: false,
      recurrence_type: 2,
      repeat_interval: 1,
      weekly_days: "",
      monthly_day: "",
      end_times: "",
      end_date_time: "",
      course: "",
        })
    }

    const validateForm = () => {
        const newErrors = {
            name: '',
            date: '',
            time: '',
            duration: '',
            is_recurring: false,
            recurrence_type: '',
            repeat_interval: '',
            weekly_days: '',
            monthly_day: '',
            end_times: '',
            end_date_time: '',
            course: ''
        };
        if (!newWebinar?.name) {
            newErrors.name = "Webinar title is required";
        }
        if (!newWebinar?.date) {
            newErrors.date = "Date is required";
        }
        if (!newWebinar?.time) {
            newErrors.time = "Time is required";
        }
        if (!newWebinar?.duration) {
            newErrors.duration = "Duration is required";
        }
        if (newWebinar.is_recurring === true) {
            if (!newWebinar.recurrence_type) {
                newErrors.recurrence_type = "Recurrence type is required";
            }
            if (!newWebinar.repeat_interval) {
                newErrors.repeat_interval = "Repeat interval is required";
            }
            if (Number(newWebinar.recurrence_type) === 2 && !newWebinar.weekly_days) {
                newErrors.weekly_days = "Weekly days are required for weekly recurrence";
            }
            if (Number(newWebinar.recurrence_type) === 3 && !newWebinar.monthly_day) {
                newErrors.monthly_day = "Monthly day is required for monthly recurrence";
            }
            if (!newWebinar.end_times && !newWebinar.end_date_time) {
                newErrors.end_times = "Either end times or end date/time is required";
                newErrors.end_date_time = "Either end times or end date/time is required";
            }
        }
        setErrors(newErrors);
        return Object.values(newErrors).every(error => !error);
    }

    const handleChange = async (name, value) => {
        if (name === "end_times") {
            setNewWebinar({
                ...newWebinar,
                end_times: value,
                end_date_time: "",
            });
            return;
        }

        if (name === "end_date_time") {
            setNewWebinar({
                ...newWebinar,
                end_date_time: value,
                end_times: "",
            });
            return;
        }

        setNewWebinar({
            ...newWebinar,
            [name]: value,
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        let convertedTime = convertStringTime(newWebinar.time);
        if (validateForm()) {
            const payload = {
                id: webinarDetails?.id,
                name: newWebinar.name,
                date: newWebinar.date ? convertStringDate(newWebinar.date) : undefined,
                time: convertedTime?.convertTime?.time,
                time_ext: convertedTime?.convertTime?.timeExt,
                duration: newWebinar.duration ? Number(newWebinar.duration) : undefined,
                is_recurring: newWebinar.is_recurring,
            };
            if (payload.is_recurring) {
                payload.recurrence_type = Number(newWebinar.recurrence_type);
                payload.repeat_interval = Number(newWebinar.repeat_interval);
                if (payload.recurrence_type === 2) {
                    payload.weekly_days = newWebinar.weekly_days;
                }
                if (payload.recurrence_type === 3) {
                    payload.monthly_day = Number(newWebinar.monthly_day);
                }
                if (newWebinar.end_times) {
                    payload.end_times = Number(newWebinar.end_times);
                }
                if (newWebinar.end_date_time) {
                    payload.end_date_time = newWebinar.end_date_time;
                }
            }
            dispatch(Actions.webinar.updateWebinarAdmin(payload));
            onClose();
            emptyFormfields();
        }
    };
    return (
        <>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    <Box>
                        <Box>
                            <TextInputComponent
                                label={"Webinar Title"}
                                placeholder="Enter webinar title"
                                name="name"
                                value={newWebinar.name}
                                onchange={(e) => handleChange("name", e.target.value)}
                                readOnly={false}
                                isError={errors?.name !== ''}
                                error={errors?.name}
                                required
                            />
                        </Box>
                        <Box>
                            <DatePickerComponent
                                label={"Date"}
                                selected={newWebinar?.date}
                                dateFormat="dd/MM/yyyy"
                                onChange={(e) => handleChange('date', e)}
                                minDate={new Date()}
                            />
                        </Box>

                        <Box>
                            <TimePickerComponent
                                value={newWebinar?.time}
                                onChange={(e) => handleChange('time', e)}
                                isError={errors?.time !== "" ? true : false}
                                error={errors?.time}
                            />
                        </Box>

                        <Box>
                            <TextInputComponent
                                type="number"
                                label={"Duration (Hours)"}
                                placeholder="Enter Webinar duration"
                                name="duration"
                                value={newWebinar?.duration}
                                onchange={(e) => handleChange('duration', e.target.value)}
                                readOnly={false}
                                isError={errors?.duration !== "" ? true : false}
                                error={errors?.duration}
                            />

                        </Box>

                        {/* <Box>
                            <DropDownComponent
                                dropdownLabel={"Courses"}
                                name="course"
                                selectedValue={webinarCourse}
                                onchange={(e) => setWebinarCourse(e.target.value)}
                                readOnly={false}
                                isError={errors?.course !== "" ? true : false}
                                error={errors?.course}
                                list={courseList}
                            />

                        </Box> */}

                        <Box sx={{ mt: 2 }}>
                            <DropDownComponent
                                list={[
                                    { id: false, name: "No (One-time)" },
                                    { id: true, name: "Yes (Recurring)" },
                                ]}
                                dropdownLabel={"Is Recurring?"}
                                selectedValue={newWebinar.is_recurring}
                                onchange={(e) => handleChange("is_recurring", e.target.value === true || e.target.value === "true")}
                            />
                        </Box>

                        {newWebinar.is_recurring && (
                            <>
                                <Box sx={{ mt: 2 }}>
                                    <DropDownComponent
                                        list={[
                                            { id: 1, name: "Daily" },
                                            { id: 2, name: "Weekly" },
                                            { id: 3, name: "Monthly" },
                                        ]}
                                        dropdownLabel={"Recurrence Type"}
                                        initialValue={"Select"}
                                        selectedValue={newWebinar.recurrence_type}
                                        onchange={(e) => handleChange("recurrence_type", Number(e.target.value))}
                                    />
                                </Box>
                                <Box sx={{ mt: 2 }}>
                                    <TextInputComponent
                                        label={"Repeat Interval"}
                                        placeholder="e.g. every 2 weeks = 2"
                                        name="repeat_interval"
                                        value={newWebinar.repeat_interval}
                                        onchange={(e) => handleChange("repeat_interval", e.target.value)}
                                        readOnly={false}
                                        isError={errors?.repeat_interval !== ""}
                                        error={errors?.repeat_interval}
                                    />
                                </Box>
                                {Number(newWebinar.recurrence_type) === 2 && (
                                    <Box sx={{ mt: 2 }}>
                                        <TextInputComponent
                                            label={"Weekly Days (comma-separated, 1=Sun, 2=Mon,...)"}
                                            placeholder="e.g. 2,4 for Mon,Wed"
                                            name="weekly_days"
                                            value={newWebinar.weekly_days}
                                            onchange={(e) => handleChange("weekly_days", e.target.value)}
                                            readOnly={false}
                                            isError={errors?.weekly_days !== ""}
                                            error={errors?.weekly_days}
                                        />
                                    </Box>
                                )}
                                {Number(newWebinar.recurrence_type) === 3 && (
                                    <Box sx={{ mt: 2 }}>
                                        <TextInputComponent
                                            label={"Monthly Day (1-31)"}
                                            placeholder="e.g. 15"
                                            name="monthly_day"
                                            value={newWebinar.monthly_day}
                                            onchange={(e) => handleChange("monthly_day", e.target.value)}
                                            readOnly={false}
                                            isError={errors?.monthly_day !== ""}
                                            error={errors?.monthly_day}
                                        />
                                    </Box>
                                )}
                                <Box sx={{ mt: 2 }}>
                                    <TextInputComponent
                                        label={"End Times (number of occurrences)"}
                                        placeholder="e.g. 10"
                                        name="end_times"
                                        value={newWebinar.end_times}
                                        onchange={(e) => handleChange("end_times", e.target.value)}
                                        readOnly={false}
                                        isError={errors?.end_times !== ""}
                                        error={errors?.end_times}
                                    />
                                </Box>
                                <Box sx={{ mt: 2 }}>
                                    <DatePickerComponent
                                        label={"End Date Time"}
                                        selected={newWebinar.end_date_time}
                                        onChange={(e) => handleChange("end_date_time", e)}
                                        isError={errors?.end_date_time !== ""}
                                        error={errors?.end_date_time}
                                        minDate={newWebinar.date ? new Date(newWebinar.date) : new Date()}
                                        showTimeSelect
                                        dateFormat="yyyy-MM-dd'T'HH:mm:ss'Z'"
                                        placeholderText="Select end date and time"
                                    />
                                </Box>
                            </>
                        )}

                    </Box>
                </DialogContent>
                <DialogActions sx={{ mr: 2, mb: 2 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <TextButtonComponet text={"Save"} width={120} onButtonClick={handleSubmit} />
                        <TextButtonComponet text={"Cancel"} classStyle="btn btn-secondary" width={120} onButtonClick={() => { onClose(); }} />
                    </Box>

                </DialogActions>
            </form>

        </>
    );
}

export default connect(
    state => ({
        courseList: state.students.get("commonCourseList"),
        webinarById: state.webinar.get("getAdminWebinarById"),
    }),
    {
        getCourseList: Actions.students.getCourseList,
        getWebinarById: Actions.webinar.getWebinarDetailsByIdAdmin,
    },
)(AdminWebinarUpdateForm);
